import useFacebookPixel from "@/hooks/useMetaPixel";
import { createContext, useContext } from "react";

import { FacebookPixel } from "react-meta-pixel";

export type MetaPixel = {
  pixel: FacebookPixel | null;
};

const MetaPixelContext = createContext<MetaPixel>({ pixel: null });

export default function MetaPixelContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // Run on prod or test
  const isDashboardDomain =
    typeof window !== "undefined" &&
    window.location.hostname === "dashboard.solarcloud.com.au";

  const pixel = isDashboardDomain ? useFacebookPixel() : null;

  const metaPixel: MetaPixel = {
    pixel,
  };

  return (
    <MetaPixelContext.Provider value={metaPixel}>
      {children}
    </MetaPixelContext.Provider>
  );
}

export const usePixelContext = () => {
  const pixel = useContext(MetaPixelContext);
  if (!pixel) {
    throw new Error(
      "useMetaPixelContext must be used within a MetaPixelProvider"
    );
  }
  return pixel;
};
